import React, {useState} from "react";
import {PageHeader} from "../../../components/PageHeader";
import BulletinboardListType from "./subPages/BulletinboardListType";
import {toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import useRequestData from "../../../hooks/useRequestData";
import {getBulletinboardList} from "../../../api/bulletinboard/BulletinboardService";
import {useParams} from "react-router-dom";

function BulletinboardList() {
    const { type } = useParams();
    const [checked,setChecked] = useState([]);

    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }

    const { newData, pageInfo, dataHook } =
        useRequestData((conditions, pageable) => {
            const additionalCondition = {
                type: type
            };
            const finalConditions = {
                ...conditions,
                ...additionalCondition
            };
            return getBulletinboardList(finalConditions, pageable);
        }, initDate, `bulletin_board_${type}`);

    return (
        <>
            <div className="common-container">
                {type === "request" ?
                    <PageHeader header={"요청자료실"} indicator={"서비스요청 > 요청자료실"} /> :
                    <PageHeader header={"자료실"} indicator={"환경설정 > 알람관리 > 자료실"} />

                }
                <BulletinboardListType
                    data={newData} date={initDate} pageInfo={pageInfo} dataHook={dataHook}
                    checked={{checked: checked, setChecked: setChecked}}
                    type= {type === "request" ? "request" : "main"}
                />
            </div>
        </>
    );

}

export default BulletinboardList;